<template>
  <v-container fluid>
    <v-card v-if="checklist">
      <v-card-title primary-title>
        <v-text-field
          v-model="checklist.name"
          label="Checklist Name"
          class="mr-10"
        ></v-text-field>
        <v-select
          :items="checklistTypes"
          v-model="checklist.checklistType"
          label="Type"
        ></v-select>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6">
            <v-text-field
              label="First Escalation Email"
              v-model="checklist.firstEscalationEmail"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="First Escelation Time"
              v-mask="'##:##'"
              v-model="checklist.firstEscalation"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              label="Second Escalation Email"
              v-model="checklist.secondEscalationEmail"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="Second Escelation Time"
              v-mask="'##:##'"
              v-model="checklist.secondEscalation"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              label="Final Escalation Email"
              v-model="checklist.finalEscalationEmail"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
              label="Final Escelation Time"
              v-mask="'##:##'"
              v-model="checklist.finalEscalation"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn color="success" @click="save">Save</v-btn>
      </v-card-actions>
      <ListChecklistItems :checklistId="id"></ListChecklistItems>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import ListChecklistItems from '../components/ListChecklistItems.vue';

export default {
  name: 'EditChecklist.vue',
  components: {
    ListChecklistItems,
  },
  data() {
    return {
      id: undefined,
      checklist: undefined,
      checklistTypes: ['Basic', 'Custom'],
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.refresh();
  },
  methods: {
    ...mapActions('checklists', ['LOAD_checklist', 'UPDATE_checklist']),
    ...mapActions('checklistItems', ['LOAD_checklistItems']),
    async refresh() {
      this.isLoading = true;
      this.checklist = await this.LOAD_checklist(this.id);
      this.isLoading = false;
    },
    async save() {
      this.isLoading = true;
      await this.UPDATE_checklist(this.checklist);
      this.isLoading = false;
      this.$router.push({ name: 'checklists-Checklists' });
    },
  },
};
</script>
